<template>
  <div>
    <v-text-field
      id="extracoes-bdgd-historico-search"
      v-model="search"
      append-icon="mdi-magnify"
      class="break-search ml-auto mt-8"
      label="Procurar"
      hide-details
      single-line
      style="max-width: 250px"
    />
    <v-data-table
      class="extracoes-bdgd-table"
      :headers="headers"
      :items="items"
      :search.sync="search"
      :mobile-breakpoint="800"
      :loading="loading"
      :hide-default-header="loading"
      :hide-default-footer="loading"
      no-data-text="Nenhuma Extração BDGD encontrada"
    >
      <template v-slot:[`item.status`]="{ item }">
        <general-status :status="item.status" />
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          id="baixar-extracao-bdgd"
          min-width="0"
          class="px-1"
          fab
          icon
          x-small
          :loading="downloadProgressData[item.id]"
          :disabled="item.status !== 'SUCESSO'"
          @click="downloadExtracao(item)"
        >
          <v-icon medium>mdi-download</v-icon>
        </v-btn>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              id="action-more-extracoes-bdgd"
              color="white"
              class="ml-1"
              height="22px"
              width="22px"
              fab
              x-small
              elevation="1"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              @click="
                ((dialogCreationLog = true),
                (dialogCreationLogData = {
                  username: item.usuario,
                  created: item.criado_em
                }))
              "
            >
              <v-list-item-title>
                <v-icon small>mdi-table-search</v-icon>
                Log
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:[`footer.page-text`]>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" v-bind="attrs" v-on="on" @click="getAllExtracoes">mdi-refresh</v-icon>
          </template>
          <span>Clique aqui para recarregar extrações processadas</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
  </div>
</template>

<script>
  import ExtracoesBdgdService from '@/services/ExtracoesBdgdService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    name: 'SecondTabContentBdgd',

    components: {
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue'),
      DialogCreationLog: () => import('@/components/general/DialogCreationLog')
    },

    mixins: [refreshDataMixins],

    props: {
      bdgdId: {
        type: [Number, String],
        required: true
      }
    },

    data() {
      return {
        headers: [
          { text: '#', value: 'id' },
          { text: 'Título', value: 'titulo' },
          { text: 'Tabela', value: 'tabela' },
          { text: 'Status', value: 'status' },
          { sortable: false, text: 'Ações', value: 'actions', class: 'pl-4' }
        ],
        items: [],
        search: null,
        loading: false,
        secondsToRefresh: 30,
        downloadProgressData: [],
        dialogCreationLog: false,
        dialogCreationLogData: {}
      };
    },

    mounted() {
      this.refreshData(this.getAllExtracoes);
    },

    methods: {
      getAllExtracoes() {
        this.loading = true;
        ExtracoesBdgdService.getAllExtracoes(this.bdgdId)
          .then(({ data }) => {
            this.items = data;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Falha ao buscar as Extrações BDGD.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      },
      downloadExtracao(item) {
        this.$set(this.downloadProgressData, item.id, true);
        ExtracoesBdgdService.baixarExtracao(item.id, { timeout: 60 * 60 * 1000 })
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `extracao-bdgd-${item.id}.zip`);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            this.$toast.error('Falha no download da extração.', '', {
              position: 'topRight'
            });
          })
          .finally(() => this.$set(this.downloadProgressData, item.id, false));
      }
    }
  };
</script>